module.exports = __webpack_public_path__ + "static/media/south_pole_pic2.75eaa43d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/south_pole_pic2.png
 ** module id = 480
 ** module chunks = 0
 **/